import { useMemo } from 'react';

export type EnvironmentSettings = {
  color: string;
  label: string;
};

const settings: Record<string, EnvironmentSettings> = {
  dev: {
    color: '#508223',
    label: 'DEV',
  },
  local: {
    color: '#ffa500',
    label: 'LOCAL',
  },
  test: {
    color: '#ffa500',
    label: 'TEST',
  },
  preprod: {
    color: '#800080',
    label: 'PREPROD',
  },
};

export function getEnvironmentSettings(environment: string | undefined) {
  if (!environment) {
    return null;
  }

  return settings[environment.toLowerCase()] ?? null;
}

export default function useEnvironment() {
  const environment = process.env.VITE_OTAP_ENVIRONMENT;
  const envSettings = useMemo(
    () => getEnvironmentSettings(environment),
    [environment],
  );

  return envSettings;
}
